import React from 'react';

import { SubjectSelectionSelectionLogicEnum } from '@ariksa/abac/api';
import { NativeResources } from '@ariksa/inventory-core';
import { Box } from '@chakra-ui/react';

import { ConditionLabel } from 'components/DataDisplay';
import { DeleteAttributeIconButton } from 'components/DataEntry';
import { IconTypes, OktaIcon } from 'components/Icons';
import { getIcon } from 'components/Icons/Components';

export const dataPolicyCloudOptions = [
  { label: 'Snowflake', value: 'snowflake' },
];
export const dataPolicyQuantifierOptions = [
  { label: 'any', value: SubjectSelectionSelectionLogicEnum.Any },
  /*{ label: 'all', value: SubjectSelectionSelectionLogicEnum.All },*/
];

export const dataPolicyAwsResourceTypeOptions = [
  {
    label: 'S3',
    value: NativeResources.SimpleStorageService,
    icon: getIcon(NativeResources.SimpleStorageService),
  },
  {
    label: 'RDS',
    value: NativeResources.RelationalDatabaseService,
    icon: getIcon(NativeResources.RelationalDatabaseService),
  },
  {
    label: 'Redshift',
    value: NativeResources.RedshiftCluster,
    icon: getIcon(NativeResources.RedshiftCluster),
  },
  {
    label: 'Cloud Lake Formation',
    value: 'CloudLakeFormation',
    icon: getIcon(IconTypes.CloudLakeFormation),
  },
];

export const dataPolicyIdentityProviderOptions = [
  { label: 'Okta', value: 'Okta', icon: <OktaIcon /> },
  { label: 'None', value: undefined },
];

export const renderDisplayNameBox = (
  name: string,
  width?: number | string,
  color?: string,
) => {
  return (
    <Box
      w={width ?? 44}
      border="1px solid"
      bg="white"
      borderRadius={6}
      borderColor="componentBorder"
      px={3}
      py="3px"
      color={color}
    >
      {name}
    </Box>
  );
};

export const renderDataPolicyConditionLabel = (
  name: string,
  label: string,
  isRequired?: boolean,
) => {
  return <ConditionLabel name={name} label={label} isRequired={isRequired} />;
};

export const renderDataAccessFormLabel = (name, width) => (
  <Box fontWeight={600} w={width}>
    {name}
  </Box>
);

export const renderDeleteAttribute = (onClick, isDisabled = false) => {
  return (
    <DeleteAttributeIconButton onClick={onClick} isDisabled={isDisabled} />
  );
};
